import { render, staticRenderFns } from "./cuaderno-obra.vue?vue&type=template&id=349c3854&"
import script from "./cuaderno-obra.vue?vue&type=script&lang=js&"
export * from "./cuaderno-obra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports